<template>
  <section class="should-you-bluff-river-steps">
    <div>
      <h4>Step {{ 6 + (state.players.numPlayers * 3) }}: What is the river card?</h4>
      <river-selector
        v-bind:presetCommunityCards="state.presetCommunityCards"
        v-bind:presetHoleCards="state.presetHoleCards"
        v-bind:disabled="!authorized"
        v-on:setIndividualPresetCommunityCard="$emit('setIndividualPresetCommunityCard', $event)"
        v-on:removePresetCommunityCard="$emit('removePresetCommunityCard', $event)"
      />
    </div>
    <bluff-size-selector
      v-bind:step="7 + (state.players.numPlayers * 3)"
      v-bind:bluffSize="state.bluffSize"
      v-bind:authorized="authorized"
      v-on:setBluffSize="$emit('setBluffSize', $event)"
    />
    <fold-equity-table
      v-if="showFoldEquityTable"
      v-bind:state="state"
      v-bind:playerStateIndex="3"
      v-bind:immediatelyProfitableBreakevenPercentage="$store.getters['guidedAnalysesBluffing/immediatelyProfitableBreakevenPercentage']"
      v-on:setProfitableBreakevenPercentage="$emit('setProfitableBreakevenPercentage', $event)"
    />
    <div v-if="state.presetCommunityCards.riverSet">
      <set-range-step
        v-for="(player, playerIndex) in state.players._players"
        v-bind:key="player.id"
        v-bind:textForStep="getTextForPlayerRangeStep(playerIndex)"
        v-bind:player="player"
        v-bind:playerIndex="playerIndex"
        v-bind:playerStateIndex="3"
        v-bind:presetCommunityCards="state.presetCommunityCards"
        v-bind:presetHoleCards="state.presetHoleCards"
        v-bind:textWhenFiveCardHandPercentagesArentUpToDate="textWhenFiveCardHandPercentagesArentUpToDate"
        v-bind:storeModuleName="'guidedAnalysesBluffing'"
        v-bind:authorized="authorized"
      >
        <river-selector
          v-if="state.streetToBluff === 'river'"
          slot="boardCardsSelector"
          v-bind:presetCommunityCards="state.presetCommunityCards"
          v-bind:presetHoleCards="state.presetHoleCards"
          v-bind:disabled="!authorized"
          v-on:setIndividualPresetCommunityCard="$emit('setIndividualPresetCommunityCard', $event)"
          v-on:removePresetCommunityCard="$emit('removePresetCommunityCard', $event)"
        />
        <range-help-section
          slot="rangeHelpSection"
          v-bind:playerStateIndex="3"
          v-bind:streetToBluff="state.streetToBluff"
        />
      </set-range-step>
    </div>
  </section>
</template>

<script>
import RiverSelector from '@/components/controls/card-selection/river-selector';
import BluffSizeSelector from '@/components/guided-analyses/should-you-bluff/bluff-size-selector';
import FoldEquityTable from '@/components/guided-analyses/should-you-bluff/conclusions/fold-equity-table';
import SetRangeStep from '@/components/guided-analyses/set-range-step';
import RangeHelpSection from '@/components/guided-analyses/should-you-bluff/help/range';
import _ from 'lodash';

export default {
  name: 'should-you-bluff-river-steps',
  components: {
    'river-selector': RiverSelector,
    'bluff-size-selector': BluffSizeSelector,
    'fold-equity-table': FoldEquityTable,
    'set-range-step': SetRangeStep,
    'range-help-section': RangeHelpSection,
  },
  props: [
    'state',
    'textWhenFiveCardHandPercentagesArentUpToDate',
    'authorized',
  ],
  computed: {
    showFoldEquityTable: function () {
      return (
        (this.state.players.numPlayers === 1) &&
        (this.state.players.find(0).states[3].hitPercentageForDifferentRanges.length > 0) &&
        (this.state.streetToBluff === 'river') &&
        (this.state.presetCommunityCards.riverSet) &&
        (!this.state.presetCommunityCards.pairedBoard)
      );
    },
  },
  methods: {
    getTextForPlayerRangeStep: function (playerIndex) {
      let numOpponents = this.state.players.numPlayers;

      if (this.state.streetToBluff === 'river') {
        if (numOpponents === 1) {
          return `Step ${8 + (numOpponents * 3) + playerIndex}: What do you think your opponent would continue with versus your ${this.state.bluffSize} pot river bluff?`;
        } else {
          return `Step ${8 + (numOpponents * 3) + playerIndex}: What do you think opponent #${playerIndex + 1} would continue with versus your ${this.state.bluffSize} pot river bluff?`
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-bluff/river-steps.vue